var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDivider = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 72,
  fill: "none",
  viewBox: "0 0 56 72"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D24A1",
  d: "m39.614-53.43 23.182 6.21-46.409 173.202-23.182-6.212z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .57h56v71H0z"
})))));
export { SvgDivider as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA1NiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41IiBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzEwXzEyNjMpIj4KPHJlY3QgeD0iMzkuNjEzNSIgeT0iLTUzLjQzMDciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNzkuMzExIiB0cmFuc2Zvcm09InJvdGF0ZSgxNSAzOS42MTM1IC01My40MzA3KSIgZmlsbD0iIzBEMjRBMSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzMxMF8xMjYzIj4KPHJlY3Qgd2lkdGg9IjU2IiBoZWlnaHQ9IjcxIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjU2OTMzNikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";